import React from 'react';

import { createProdStackManagerLayotClassName } from './prodStackManagerLayoutStyles';

type Props = {
  theme: 'light' | 'dark';
  logo: React.ReactNode;
  content: React.ReactNode;
  controls: React.ReactNode;
};

export const ProdStackManagerLayoutComponent = (props: Props) => {
  const { logo, content, controls, theme } = props;

  const wrapperClassName = createProdStackManagerLayotClassName('wrapper', {
    theme,
  });

  const logoClassName = createProdStackManagerLayotClassName('logo');

  const bodyClassName = createProdStackManagerLayotClassName('body');

  const contentSlotClassName = createProdStackManagerLayotClassName(
    'contentSlot'
  );

  const controlsClassName = createProdStackManagerLayotClassName('controls');

  return (
    <div className={wrapperClassName}>
      <div className={logoClassName}>{logo}</div>
      <div className={bodyClassName}>
        <div className={contentSlotClassName}>{content}</div>
      </div>
      <div className={controlsClassName}>{controls}</div>
    </div>
  );
};

export const ProdStackManagerContentLayoutComponent: React.FC = (props) => {
  const { children } = props;

  const contentClassName = createProdStackManagerLayotClassName('content');

  return <div className={contentClassName}>{children}</div>;
};
